// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3QXjm","tab":"Tabs_tab__2h87I","tabActive":"Tabs_tabActive__1yE6L"};